import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  variant?: 'default' | 'compact';
}

export default function MovieCard({ movie, variant = 'default' }: MovieCardProps) {
  return (
    <Link
      to={`/article/${movie.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative aspect-[2/3] overflow-hidden rounded-lg bg-background-200 mb-3">
        <img
          src={movie.imageUrl}
          alt={movie.title}
          title={`${movie.title} - 6080影院电影大全`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 bg-accent-500/90 text-background-50 text-xs rounded whitespace-nowrap">
            {movie.rating}
          </span>
        </div>
        {movie.featured && (
          <div className="absolute top-2 right-2">
            <span className="px-2 py-0.5 bg-primary-500/90 text-background-50 text-xs rounded whitespace-nowrap">
              推荐
            </span>
          </div>
        )}
        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <span className="inline-block px-3 py-1.5 bg-primary-500 text-background-50 text-xs rounded-md whitespace-nowrap">
            立即观看
          </span>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-900 group-hover:text-accent-600 transition-colors line-clamp-1 font-heading">
        {movie.title}
      </h3>
      <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
        <span>{movie.year}</span>
        <span className="w-0.5 h-0.5 rounded-full bg-foreground-400"></span>
        <span>{movie.category}</span>
      </div>
    </Link>
  );
}